import { routerStyxie } from '@/router/styxieBridge'

// Client-side routed; the page has no styxie payload (see router/routes/mlap.js).
Styxie.Initializers.MlapSettingsGeogrids = routerStyxie({ actions: ['index']})
